import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {FaqArticlesCreators as Creators} from "./redux"
import {translate} from "react-i18next"

import {Container, Row, Col} from "../../components/Grid"
import Button from "../../components/Button"
import Sidebar from "../../components/Sidebar"
import Breadcrumbs from "../../components/Breadcrumbs"
import Loader from "../../components/Loader"
import Message from "../../components/Message"

import styles from "./styles.css"

class FAQArticles extends Component {
  constructor(props) {
    super(props)

    this.state = {
      active: false,
      isMobile: false,
      activeDropdown: "",
      activeLink: "",
      lastUsedHash: ""
    }

    this.updatePredicate = this.updatePredicate.bind(this)
    this.articleRefs = {}
  }

  static propTypes = {
    error: PropTypes.string,
    fetching: PropTypes.bool,
    category: PropTypes.object.isRequired,
    articles: PropTypes.array.isRequired,
    sidebar: PropTypes.array.isRequired
  }

  static defaultProps = {
    category: {},
    articles: [],
    sidebar: [],
    fetching: false,
    error: null
  }

  componentDidMount() {
    this.updatePredicate()
    window.addEventListener("resize", this.updatePredicate)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate)
  }

  componentDidUpdate(_prevProps) {
    // check for hash and open article if it exists
    const hash = this._getHash()

    if (hash && this.articleRefs[hash] && this.state.lastUsedHash !== hash) {
      this._openArticleByHash(hash)
    }
  }

  updatePredicate() {
    this.setState({isMobile: window.innerWidth < 768})
  }

  slideToggle(e) {
    let activeDropdown = this.state.activeDropdown
    let activeLink = this.state.activeLink
    let dropdown = e.target.nextElementSibling
    if (e.target.classList.contains("is-active")) {
      e.target.classList.remove("is-active")
      dropdown.classList.remove("is-open")
      dropdown.style.height = "0px"
      dropdown.addEventListener(
        "transitionend",
        () => {
          dropdown.classList.remove("active")
        },
        {once: true}
      )
      this.setState(prevState => {
        return {
          ...prevState,
          activeDropdown: "",
          activeLink: ""
        }
      })
    } else {
      if (activeLink !== "") {
        activeLink.classList.remove("is-active")
      }
      if (activeDropdown !== "") {
        activeDropdown.classList.remove("is-open")
        activeDropdown.style.height = "0px"
        activeDropdown.addEventListener(
          "transitionend",
          () => {
            activeDropdown.classList.remove("active")
          },
          {once: true}
        )
      }

      e.target.classList.add("is-active")
      dropdown.classList.add("is-open")
      dropdown.style.height = "auto"
      var height = dropdown.clientHeight + "px"
      dropdown.style.height = "0px"
      setTimeout(() => {
        dropdown.style.height = height
      }, 0)

      activeLink = e.target
      this.setState(prevState => {
        return {
          ...prevState,
          activeDropdown: dropdown,
          activeLink: activeLink
        }
      })
    }
  }

  getCategoryName() {
    return typeof this.props.category.category === "undefined"
      ? null
      : this.props.category.category.name
  }

  getTags() {
    const {tags} = this.props

    return Object.keys(tags).map((tag, index) => {
      return (
        <button
          className={`${tag}`}
          key={index}
          value={tag}
          onClick={e => this._handleTagsFetch(e)}
        >
          {tags[tag]}
        </button>
      )
    })
  }

  _getHash() {
    return this.props.router.hash === ""
      ? null
      : this.props.router.hash.replace("#", "")
  }

  _setArticleRef(name, elem) {
    this.articleRefs[name] = elem
  }

  _openArticleByHash(hash) {
    const node = this.articleRefs[hash]

    if (node) {
      this.setState(prevState => {
        return {...prevState, lastUsedHash: hash}
      })

      // trigger click on toggle
      node.querySelector(".toggler").click()

      // scroll to node
      setTimeout(() => {
        const bounding = node.getBoundingClientRect()
        const scrollValue = Math.floor(bounding.top) + window.scrollY - 115 // last value is safe space

        window.scrollTo(0, scrollValue)
      }, 350)
    }
  }

  getArticles() {
    const {articles} = this.props
    return articles.map((article, index) => {
      return (
        <div
          className={`${styles.Article} item-${index}`}
          key={article.ID}
          ref={elem => this._setArticleRef(`article-${article.ID}`, elem)}
        >
          <div onClick={e => this.slideToggle(e)} className="toggler">
            <span>{article.post_title}</span>
            <i className="icon icon-arrow-down" />
          </div>
          <div className="dropdown">
            <div dangerouslySetInnerHTML={{__html: article.post_content}} />
            {article.fields.button.show ? (
              <Button
                theme="cyan"
                size="small"
                href={article.fields.button.link}
                target={article.fields.button.target}
              >
                {article.fields.button.text}
              </Button>
            ) : null}
          </div>
        </div>
      )
    })
  }

  render() {
    const {category, sidebar, error, fetching, t, lang} = this.props

    if (error) {
      return (
        <Message error>
          <p>
            <strong>{t("Es ist ein Fehler aufgetreten.")}</strong>
            <br />
            {error}
          </p>
        </Message>
      )
    }

    const breadcrump_items = [
      {
        title: `${t("Startseite")}`,
        href: `/${lang}/`
      },
      {
        title: category.name,
        href: null
      }
    ]

    return (
      <div className={this.props.category.taxonomy}>
        <Loader active={fetching} />
        <div className={styles.IntroBlock}>
          <Container>
            <Row className="row-fluid">
              <Col md={10} xl={7} className="col-left">
                <div className="wp-content">
                  <Row className="row-fluid">
                    <Col>
                      <div className="text_column">
                        <h1
                          className="headline"
                          dangerouslySetInnerHTML={{__html: category.name}}
                        />
                        <p
                          className="description no-margin"
                          dangerouslySetInnerHTML={{
                            __html: category.description
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="container-breadcrumbs">
          <Container>
            <Row className="row-fluid">
              <Breadcrumbs items={breadcrump_items} theme="cyan" />
            </Row>
          </Container>
        </div>
        <div className="inside">
          <Container>
            <Row className="row-fluid">
              <Col>
                <h3 className="headline">FAQ</h3>
              </Col>
              <Col lg={4}>
                <Sidebar
                  items={sidebar}
                  currentPage={category.taxonomy}
                  theme={"cyan"}
                />
              </Col>
              <Col lg={8}>
                <Row className="row-fluid no-padding">
                  <Col className="no-padding-right">{this.getArticles()}</Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state.faqarticles,
    slug: state.router.params.slug,
    lang: state.app.lang,
    router: state.router
  }
}

const mapDispatchToProps = dispatch => {
  return {
    moreArticles: slug => dispatch(Creators.request(slug))
  }
}

FAQArticles = connect(
  mapStateToProps,
  mapDispatchToProps
)(FAQArticles)
export default translate()(FAQArticles)

export {reducer} from "./redux"
export {default as sagas} from "./sagas"



// WEBPACK FOOTER //
// ./src/containers/FAQArticles/index.js